// extracted by mini-css-extract-plugin
export default {"card":"styles_card__8o11C","wordingContainer":"styles_wordingContainer__WY+Z+"};